import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Download, ArrowRight } from "lucide-react";
const applications = [{
  id: 1,
  title: "Cloud Strategy",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/cloud_architecture_consulting.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/cloud_architecture_consulting.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/cloud_architecture_consulting.png-wvc-sizes",
    alt: "Abstract cloud computing architecture visualization"
  }
}, {
  id: 2,
  title: "AI Integration",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/generative_ai_mentoring.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/generative_ai_mentoring.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/generative_ai_mentoring.png-wvc-sizes",
    alt: "Neural network nodes representing artificial intelligence"
  }
}, {
  id: 3,
  title: "Thought Leadership",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/tech_influencer_publications.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/tech_influencer_publications.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/tech_influencer_publications.png-wvc-sizes",
    alt: "Modern tech publication and book covers"
  }
}];
export default function SocialStream() {
  return <section data-section-id="258988" id="social-stream" className="bg-background py-32">
      <div className="container mx-auto px-4">
        
        {}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 mb-24">
          {applications.map((app, i) => <div key={app.id} data-index={i} className="group relative overflow-hidden rounded-md shadow-xl bg-card border border-border">
              <AspectRatio ratio={4 / 3}>
                <img src={app.image.src} data-wvc-srcset={app.image.srcset} data-wvc-sizes={app.image.sizes} alt={app.image.alt} className="object-cover w-full h-full transition-transform duration-700 group-hover:scale-105 opacity-80 group-hover:opacity-100" loading="lazy" />
              </AspectRatio>
              <div className="absolute inset-0 bg-gradient-to-t from-background/90 via-background/40 to-transparent flex items-end p-6 md:p-8">
                <h3 className="text-foreground font-default text-2xl md:text-3xl font-extrabold tracking-tighter">
                  {app.title}
                </h3>
              </div>
            </div>)}
        </div>

        {}
        <div className="max-w-4xl mx-auto text-center flex flex-col items-center bg-card/50 backdrop-blur-xl p-10 md:p-16 rounded-md shadow-2xl border border-border">
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-extrabold text-foreground mb-8 leading-tight tracking-tighter">
            Ready to scale your AI and Cloud initiatives?
          </h2>
          <div className="flex flex-col sm:flex-row gap-4 justify-center w-full sm:w-auto">
            <Button asChild size="lg" className="w-full sm:w-auto text-base h-12 px-8 bg-primary text-primary-foreground hover:opacity-90 rounded-md font-default font-bold">
              <Link to="/ServicesPage">
                Book a Consultation <ArrowRight className="ml-2 size-5" />
              </Link>
            </Button>
            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto text-base h-12 px-8 border-primary text-primary hover:bg-primary/10 rounded-md font-mono">
              <Link to="/LibraryPage">
                <Download className="mr-2 size-5" /> View Publications
              </Link>
            </Button>
          </div>
        </div>

      </div>
    </section>;
}